module.exports = __webpack_public_path__ + "static/media/strategy-01.15199ac6.png";